// extracted by mini-css-extract-plugin
export var animationContainer = "_eu-0";
export var asteriskIcon = "_eu-8";
export var conversationLeftSection = "_eu-4";
export var conversationListItem = "_eu-3";
export var conversationMiddleSection = "_eu-5";
export var conversationRightSection = "_eu-6";
export var detailsContent = "_eu-1";
export var listContainer = "_eu-7";
export var modalContent = "_eu-2";